import type { Body, Meta, UppyOptions, Uppy } from '@uppy/core'
import { BasePlugin } from '@uppy/core'

/**
 * A plugin that removes files whose uploads have completed when
 * the user adds new files.
 */
export default class ClearOldFilesPlugin<M extends Meta, B extends Body> extends BasePlugin<
  UppyOptions<M, B>,
  M,
  B
> {
  title: string

  constructor(uppy: Uppy<M, B>, opts?: UppyOptions<M, B>) {
    super(uppy, opts)

    this.type = 'modifier'
    this.id = 'ClearOldFiles'
    this.title = 'Clear old files'

    this.removeCompletedFiles = this.removeCompletedFiles.bind(this)
  }

  removeCompletedFiles() {
    const files = this.uppy.getFiles()
    files.forEach((file) => {
      if (file && file.progress && file.progress.uploadComplete) {
        this.uppy.removeFile(file.id)
      }
    })
  }

  install() {
    this.uppy.on('file-added', this.removeCompletedFiles)
  }

  uninstall() {
    this.uppy.off('file-added', this.removeCompletedFiles)
  }
}
